// extracted by mini-css-extract-plugin
module.exports = {"searchFilterContainer":"search-filter_searchFilterContainer__OvKU3","header":"search-filter_header__icx_o","aggLabel":"search-filter_aggLabel__ZXKON"};